<template>
  <zt-modal
    :active="closeUploadModal"
    class="rounded"
    max-width="53rem"
    max-height="53rem"
    @close="(closeUploadModal = false), $emit('close-library-modal')">
    <template slot="modal-header">
      <div class="p-4 font-bold text-zt-lg">
        <h4>{{ $t('message.customEmails.select_file') }}</h4>
      </div>
    </template>

    <div class="p-4">
      <ul class="flex mb-0 list-none flex-wrap pt-3 pb-4 flex-row">
        <li class="-mb-px last:mr-0 flex-auto text-center">
          <a
            class="cursor-pointer text-base font-bold capitalize px-5 py-3 block leading-normal rounded-l"
            @click="toggleTabs(1)"
            v-bind:class="{
              'text-indigo-800 bg-white border border-gray-800': openTab !== 1,
              'text-white bg-indigo-800': openTab === 1,
            }">
            {{ $t('message.customEmails.load') }}
          </a>
        </li>
        <li class="-mb-px last:mr-0 flex-auto text-center rounded-r">
          <a
            class="cursor-pointer text-base font-bold capitalize px-5 py-3 block leading-normal rounded-r"
            @click="toggleTabs(2)"
            v-bind:class="{
              'text-indigo-800 bg-white border border-gray-800': openTab !== 2,
              'text-white bg-indigo-800': openTab === 2,
            }">
            {{ $t('message.customEmails.library') }}
          </a>
        </li>
      </ul>

      <div class="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 rounded">
        <div class="px-1 py-2 flex-auto">
          <div class="tab-content tab-space">
            <div v-if="openTab === 1">
              <uploadImage
                :selectFile="selectFile"
                :successMessage="successMessage"
                :error="error" />
            </div>
            <div v-if="openTab == 2">
              <imageLibrary :galleryImgs="galleryImgs" :selectCompanyImage="selectCompanyImage" :imageSelected="imageSelected"/>
            </div>
          </div>
        </div>
      </div>
    </div>

    <template slot="modal-footer">
      <div class="zt-modal-footer d-flex justify-between items-center p-4 bg-zt-dark-100">
        <div>
          <zt-button @click="restoreImageSection(), cleanMsg()"  class="ml-1 button-cancel-only-text w-11/12" data-vs-button="restore">
            {{ $t('message.customEmails.restore') }}
          </zt-button>
        </div>
        <div class="d-flex justify-end">
          <zt-button @click="$emit('close-library-modal'), cleanMsg()" class="ml-1 button-cancel-only-text w-11/12" data-vs-button="cancel">
            {{ $t('message.customEmails.cancel') }}
          </zt-button>
          <zt-button :disabled="successMessage === '' && openTab === 1" :loader="loaderBtn && openTab === 1" @click="saveCompanyImage" class="ml-1 w-11/12" data-vs-button="save">{{ $t('message.customEmails.save') }}</zt-button>
        </div>
      </div>
    </template>
  </zt-modal>
</template>

<script>
  import Emails from '@/apiClient/Emails';
  import uploadImage from './uploadImage';
  import imageLibrary from './imageLibrary';

  export default {
    name: 'libraryModal',
    components: {
      uploadImage,
      imageLibrary,
    },
    props: {
      value: Boolean,
      loaderBtn: Boolean,
      editingSection: Object,
      defaultSections:Array
    },
    data() {
      return {
        modalViewState: false,
        openTab: 2,
        file: '',
        error: '',
        successMessage: '',
        emails: '',
        galleryImgs: [],
        imageSelected: '',
        loaderBtn:false
      };
    },
    created() {
      this.emails = new Emails();
      this.sectionEdit()
      this.getGallery();
    },
    computed: {
      closeUploadModal: {
        get() {
          return this.modalViewState;
        },
        set(value) {
          this.modalViewState = value;
        }, 
      },
     
    },
    watch: {
      value(newVal) {
        this.modalViewState = newVal;
        this.imageSelected =this.editingSection.value
      },
      file(val) {
        if (!val) this.error = '';
      },

    },
    
    methods: {
      toggleTabs: function (tabNumber) {
        this.openTab = tabNumber;
      },
      sectionEdit(){
        this.imageSelected = this.editingSection.value
      },
      async getGallery() {
        try {
          const response = await this.emails.getCompanyGallery()
          this.galleryImgs = response.data.data
        } catch (error) {
          console.log(error);
        }
      },
      selectFile(value) {
        this.file = value;
        this.cleanMsg();
        const filetypes = ['image/jpeg', 'image/png'];
        if (this.file.size > 1000000) {
          this.error = this.$t('message.customEmails.errors.IMAGE_LIMIT_SIZE');
        } else if (!filetypes.includes(this.file.type)) {
          this.error = this.$t('message.customEmails.errors.IMAGE_TYPE');
        } else {
          this.successMessage = this.$t('message.customEmails.succesMessage');
        }
      },
      saveCompanyImage(){
        if (this.openTab === 1) {
        if(this.error === ''){
          this.loaderBtn = true
          const params = { image: this.file }
            this.emails.postCompanyImage(params).then((result) => {
            this.file = null
            this.getGallery()
            this.loaderBtn = false
            this.openTab = 2
            this.successMessage = ''
          }).catch((err) => {
            this.loaderBtn = false
            const {code} = err.response.data.codes[0]
            this.successMessage = '';
            code === 'COMPANY_GALLERY_LIMIT_EXCEPTION' ? this.error = this.$t('message.customEmails.errors.COMPANY_GALLERY_LIMIT_EXCEPTION') : this.error = code 
          });
        }}
        else {
          this.loaderBtn = false
          this.$emit('save-image',this.imageSelected)
          this.$emit('close-library-modal')
          this.cleanMsg();
        }
      },
      selectCompanyImage(image) {
        this.imageSelected = image
      },
      restoreImageSection() {
        this.cleanMsg;
        const defaultSection = this.defaultSections.find(section => section.name == this.editingSection.name);
        this.imageSelected =defaultSection.value
        if(!this.galleryImgs.includes(this.imageSelected)){
          this.$emit('save-image',this.imageSelected)
          this.$emit('close-library-modal')
        }
      },
      cleanMsg(){
        this.successMessage = '';
        this.error = '';
      },
    },
  };
</script>

<style scoped lang="scss">
  .zt-modal-footer {
    background-color: #eeeeee;

    .zt-button {
      box-shadow: none;
      font-size: 1rem;
      font-weight: 500;
    }
    .button-cancel-only-text {
      background-color: #eeeeee !important;
      color: #949494 !important;
    }
  }
</style>
